import React from 'react'
import cn from 'classnames'
import styles from './styles.css'

const ListInspector = ({ isEmpty }) => {
  return (
    <div
      className={cn(styles.ListInspector, {
        [styles['ListInspector-empty']]: isEmpty,
      })}
    />
  )
}

export default ListInspector
